module.exports = __webpack_public_path__ + "static/masleague-77583bc94e72e758edfce6083d4d31af.png";